/* eslint-disable @nx/enforce-module-boundaries */
import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TabElementContent } from 'admin-drivers/src/app/common/components/detail-tab-item/models/TabElement';
import { map } from 'rxjs';
import { DetailTabItemComponent } from 'admin-drivers/src/app/common/components/detail-tab-item/detail-tab-item.component';
import { DatePipe } from '@angular/common';
import { VersionControlService } from 'admin-drivers/src/app/api/services/version-control.service';

@Component({
  selector: 't-llevo-version-control-detail-tab',
  standalone: true,
  imports: [DetailTabItemComponent],
  template: `
    <t-llevo-detail-tab-item 
      [data]="data() ?? []" 
      contentClasses="my-1 mx-3"
    > 
    </t-llevo-detail-tab-item>
  `,
})
export class VersionControlDetailTabComponent {
  srv = inject(VersionControlService);
  data = toSignal<TabElementContent[] | null>(
    this.srv.item$.pipe(
      map((data) => {
        if (data) {
          const required = data.required ? 'Requerida' : 'No requerida';

          const tabElements = [
            {
              name: 'Nombre de versión',
              value: data.versionName,
            },
            {
              name: 'Código de versión',
              value: data.versionCode,
            },
            {
              name: 'Nombre de paquete',
              value: data.packageName,
            },
            {
              name: 'Actualización obligatoria',
              value: required,
            },
            {
              name: 'Enlace de descarga',
              value: data.urlDownload,
            },
            {
              name: 'Fecha de actualización',
              value: new DatePipe('en-US').transform(
                data.createdAt,
                'dd/MM/yyyy - hh:mm a'
              ) as string,
            },
          ]

          if(data.description){
            tabElements.push({
              name: 'Descripción',
              value: data.description,
            })
          }

          return tabElements
        }

        return null;
      })
    )
  );
}
